import gql from 'graphql-tag';

import type { Workspace } from 'src/data/workspace';
import { executeGqlQuery, type GqlQueryOptions } from 'src/graphql/client';
import { getSingleProp, type GraphQLEdgesResult, unwrapEdges } from 'src/lib/graphql';
import type { BackendQueryWorkspacesArgs } from 'src/types/backend';

import { WORKSPACE_DEFAULT_TOV_ANALYZER_FOR_TOOL_FRAGMENT } from './schema';

const QUERY = gql`
  query WorkspaceDefaultTovAnalyzerForTool($customerId: ID!, $id: ID) {
    workspaces(customerId: $customerId, id: $id) {
      edges {
        node {
          ...WorkspaceDefaultTovAnalyzerForTool
        }
      }
    }
  }

  ${WORKSPACE_DEFAULT_TOV_ANALYZER_FOR_TOOL_FRAGMENT}
`;

type Variables = Pick<BackendQueryWorkspacesArgs, 'customerId' | 'id'>;
type Result = Pick<Workspace, 'id' | 'defaultTovAnalyzerForTool'>;

export const queryWorkspaceDefaultTovAnalyzerForTool = async (
  variables: Variables,
  options?: Pick<GqlQueryOptions, 'abortSignal'>
) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  const data = getSingleProp<GraphQLEdgesResult<Result>>(result.data);
  const items = unwrapEdges(data?.edges);
  return items[0];
};
